export const useNumberEventHandlers = ({ type, value, max, min, onChange, onBlur, onKeyDown, step = 1, }) => {
    const setValidNumber = (e, newValue) => {
        e.currentTarget.value = isNaN(newValue) ? "" : newValue.toString();
        const changeEvent = Object.assign(Object.assign({}, e), { target: e.currentTarget });
        onChange(changeEvent);
    };
    const handleArrowUp = (e, currentValue) => {
        e.preventDefault();
        const newValue = currentValue + step;
        if (min && newValue < min) {
            setValidNumber(e, min);
        }
        else if ((max && newValue <= max) || max === undefined) {
            setValidNumber(e, newValue);
        }
    };
    const handleArrowDown = (e, currentValue) => {
        e.preventDefault();
        const newValue = currentValue - step;
        if (max && newValue > max) {
            setValidNumber(e, max);
        }
        else if ((min && newValue >= min) || min === undefined) {
            setValidNumber(e, newValue);
        }
    };
    const onKeyDownHandler = (e) => {
        const currentValue = parseFloat(e.currentTarget.value);
        e.key === "ArrowUp" && handleArrowUp(e, currentValue);
        e.key === "ArrowDown" && handleArrowDown(e, currentValue);
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    };
    const onBlurHandler = (e) => {
        let parsedValue = parseFloat(e.currentTarget.value);
        if (min && parsedValue < min) {
            parsedValue = min;
        }
        if (max && parsedValue > max) {
            parsedValue = max;
        }
        setValidNumber(e, parsedValue);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    const ariaValueNow = typeof value === "string" ? (isNaN(parseFloat(value)) ? undefined : parseFloat(value)) : value;
    const defaultInputProps = { type, onBlur, onKeyDown };
    const numberInputProps = {
        type: "text",
        step,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": ariaValueNow,
        role: "spinbutton",
        onKeyDown: onKeyDownHandler,
        onBlur: onBlurHandler,
    };
    return type === "number" ? numberInputProps : defaultInputProps;
};
//# sourceMappingURL=useNumberEventHandlers.js.map